import React from 'react';

const TitleLarge = ({ children }) => {
	return <h1 className='title-bigger text-center mb-4'>{children}</h1>;
};

export default TitleLarge;
